import { Injectable } from '@angular/core';
import { HttpDataService } from '../http/http-data.service';


export interface ISOWInfo {
  sowType: string;
  hasSow: boolean;
  ticketId: number;
}

export const SOW_TYPE_SERVICE: string = 'SERVICE';

@Injectable()
export class SOWDataService {

  constructor(
    private httpDataService:HttpDataService
  ) {
  }

  public checkSOWInfo(sowType: string, webshopId: number, countryId: number): Promise<ISOWInfo> {
    return this.httpDataService.doGET(
      `rest/sows/${sowType}/info`,
      { webshopId, countryId },
      'Loading service ticket info...',
      'Failed to get SOW info'
    );
  }
}